// extracted by mini-css-extract-plugin
module.exports = {"container_user":"matching_container_user__3smhf","infos":"matching_infos__3Vo5Q","image":"matching_image__3hZlA","name":"matching_name__2wzbG","info":"matching_info__LUUOy"};